import "../../styles/all.css"
import "../../styles/theme.css"
import "./projects.css"
function Projects(){
    return(
        <>
        <div className="projects">
             <div className="startt">
                <h4>Projects</h4>
                <div className="point">
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
            </div>
            <div className="cardproject">
                <div className="row">
                    <div className="col-md-4">
                     <div className="cardone">
  <div className="text">
    <h4>Nft Mobile Apps Development</h4>
    <h5>Deadline : 20 Day Left</h5>
  </div>

  <div className="percentage">
    <div
      className="circle"
      style={{ "--value": 70 }}
    >
      <span>70%</span>
    </div>
  </div>
</div>


                    </div>
                     <div className="col-md-4">
                     <div className="cardtwo">
  <div className="text">
    <h4>Nft Mobile Apps Development</h4>
    <h5>Deadline : 20 Day Left</h5>
  </div>

  <div className="percentage">
    <div
      className="circle"
      style={{ "--value": 90 }}
    >
      <span>90%</span>
    </div>
  </div>
</div>


                    </div>
                     <div className="col-md-4">
                     <div className="cardthree">
  <div className="text">
    <h4>Nft Mobile Apps Development</h4>
    <h5>Deadline : 20 Day Left</h5>
  </div>

  <div className="percentage">
    <div
      className="circle"
      style={{ "--value": 80 }}
    >
      <span>80%</span>
    </div>
  </div>
</div>


                    </div>
                     <div className="col-md-4">
                     <div className="cardfour">
  <div className="text">
    <h4>Nft Mobile Apps Development</h4>
    <h5>Deadline : 20 Day Left</h5>
  </div>

  <div className="percentage">
    <div
      className="circle"
      style={{ "--value": 75 }}
    >
      <span>75%</span>
    </div>
  </div>
</div>


                    </div>
                     <div className="col-md-4">
                     <div className="cardfive">
  <div className="text">
    <h4>Nft Mobile Apps Development</h4>
    <h5>Deadline : 20 Day Left</h5>
  </div>

  <div className="percentage">
    <div
      className="circle"
      style={{ "--value": 95 }}
    >
      <span>95%</span>
    </div>
  </div>
</div>


                    </div>
                     <div className="col-md-4">
                     <div className="cardsix">
  <div className="text">
    <h4>Nft Mobile Apps Development</h4>
    <h5>Deadline : 20 Day Left</h5>
  </div>

  <div className="percentage">
    <div
      className="circle"
      style={{ "--value": 35 }}
    >
      <span>35%</span>
    </div>
  </div>
</div>


                    </div>
                </div>

            </div>
        </div>
        </>
    )
}
export default Projects